export const getGeoCode = (async (address) => {
    const searchAddress = encodeURIComponent(`${address}`)
    let apiKey = 'AIzaSyD4pfCExrP2jhurv5J544dFFl7UpoPDGVk';
    let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${searchAddress}&key=${apiKey}`;

    const searchLocation = await fetch(url)
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.error(
                'There was a problem with fetching that location from Google:',
                error,
            );
        });

    return searchLocation
})